import { SlideToggleFieldConfig, FieldTypeEnum, FlexLayoutConfig, DynamicFormConfig, FilterSelectFieldConfig } from "@mydocma/dynamic-form";
import { SelectFieldConfig } from "@mydocma/dynamic-form/lib/fields/select/select-field.config";


export enum OptionsFieldsEnum  {
  columnSize = 'columnSize',
  printResolution = 'printResolution',
  paperFormat = 'paperFormat',
  orientation = 'orientation'
}

export const optionsColumnSizing: SlideToggleFieldConfig = {
  id: OptionsFieldsEnum.columnSize,
  name: OptionsFieldsEnum.columnSize,
  label: {
    text: 'MM.report.tabs.options.columnSize'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};

export const optionsPrintHighResolutionImages: SlideToggleFieldConfig = {
  id: OptionsFieldsEnum.printResolution,
  name: OptionsFieldsEnum.printResolution,
  label: {
    text: 'MM.report.tabs.options.highResolution'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};

export const optionsPaperFormat: FilterSelectFieldConfig = {
  id: OptionsFieldsEnum.paperFormat,
  name: OptionsFieldsEnum.paperFormat,
  label: {
    text: 'MM.report.tabs.options.paperFormat'
  },
  source: [{
    id: 'A5',
    text: 'A5'
  }, {
    id: 'A4',
    text: 'A4'
  }, {
    id: 'A3',
    text: 'A3'
  },  {
    id: 'A2',
    text: 'A2'
  }, {
    id: 'B4',
    text: 'B4'
  }, {
    id: 'B5',
    text: 'B5'
  }, {
    id: 'Letter',
    text: 'Letter'
  }],
  value: 'A4',
  type: FieldTypeEnum.filterSelect,
  removeClearButton: true
};

export const optionsOrientation: FilterSelectFieldConfig = {
  id: OptionsFieldsEnum.orientation,
  name: OptionsFieldsEnum.orientation,
  label: {
    text: 'MM.report.tabs.options.orientation'
  },
  value: 2,
  type: FieldTypeEnum.filterSelect,
  removeClearButton: true
};


export const optionsLayout: FlexLayoutConfig = {
  name: 'optionsLayout',
  cols: [
  ],
  rows: [],
  fields: [
    {
      fieldName: OptionsFieldsEnum.columnSize,
      col: 0,
      row: 0,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: OptionsFieldsEnum.printResolution,
      col: 0,
      row: 1,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: OptionsFieldsEnum.paperFormat,
      col: 0,
      row: 2,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: OptionsFieldsEnum.orientation,
      col: 0,
      row: 3,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
  ]
}


export const optionsLayoutMobile: FlexLayoutConfig = {
  name: 'optionsLayout',
  fields: [
    {
      fieldName: OptionsFieldsEnum.columnSize,
      col: 0,
      row: 0,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: OptionsFieldsEnum.printResolution,
      col: 0,
      row: 1,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: OptionsFieldsEnum.paperFormat,
      col: 0,
      row: 2,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: OptionsFieldsEnum.orientation,
      col: 0,
      row: 1,
      maxCollapsedWidth: 0,
      layoutAlign: 'start center'
    },
  ]

}


export const optionsFormConfig: DynamicFormConfig = {
  fields: [optionsColumnSizing, optionsPrintHighResolutionImages,  optionsPaperFormat, optionsOrientation],
  layouts: [optionsLayout, optionsLayoutMobile],
};
